export default {
  //  用户管理
  // 用户列表
  member_list_add_white: "member_list_add_white",
  member_list_add_black: "member_list_add_black",
  member_list_order_remark_list: "member_list_order_remark_list",
  // 订单备注
  // member_order_remark_export: "member_order_remark_export",
  // 黑名单列表
  member_black_list_add: "member_black_list_add",
  member_black_list_edit: "member_black_list_edit",
  member_black_list_del: "member_black_list_del",
  member_black_list_add_white: "member_black_list_add_white",
  // 白名单列表
  member_white_list_add: "member_white_list_add",
  member_white_list_edit: "member_white_list_edit",
  member_white_list_del: "member_white_list_del",
  member_white_list_add_black: "member_white_list_add_black",

  //  订单管理
  // 门店订单
  order_list_export: "order_list_export",
  order_list_data_import: "order_list_data_import",
  order_list_detail: "OrderDetail",
  order_list_delivery: "OrderDelivery",
  order_list_cancel: "order_list_cancel",
  order_list_cancel_high: "order_list_cancel_high",
  order_list_bill: "OrderBill",
  order_list_contract: "order_list_contract",
  order_list_complete: "order_list_complete",
  order_list_ahead_return: "order_list_ahead_return",
  order_list_offline_pay: "order_list_offline_pay",
  order_list_delivery_detail: "order_list_delivery_detail",
  order_list_after_sale_status: "order_list_after_sale_status",
  order_list_device_status: "order_list_device_status",
  order_list_confirm_receive: "order_list_confirm_receive",
  order_list_detail_store_calc: "order_list_detail_store_calc",
  order_list_detail_edit_address: "order_list_detail_edit_address",
  // 商城订单
  mall_order_list_export: "mall_order_list_export",
  mall_order_list_detail: "OrderDetail",
  mall_order_list_delivery: "OrderDelivery",
  mall_order_list_cancel: "mall_order_list_cancel",
  mall_order_list_cancel_high: "mall_order_list_cancel_high",
  mall_order_list_bill: "OrderBill",
  mall_order_list_contract: "mall_order_list_contract",
  mall_order_list_complete: "mall_order_list_complete",
  mall_order_list_ahead_return: "mall_order_list_ahead_return",
  mall_order_list_offline_pay: "mall_order_list_offline_pay",
  mall_order_list_after_sale_status: "mall_order_list_after_sale_status",
  // 账单列表
  order_bill_list_export: "order_bill_list_export",
  order_bill_list_today_export: "order_bill_list_today_export",

  //  审核管理
  // 审核列表
  review_list_draw: "review_list_draw",
  review_list_abandon: "review_list_abandon",
  review_list_detail: "ReviewOrderDetail",
  review_list_detail_edit_address: "review_list_detail_edit_address",
  review_list_detail_edit_price_rate: "review_list_detail_edit_price_rate",
  review_list_detail_edit_cost_price: "review_list_detail_edit_cost_price",
  // review_list_detail_edit_final_grade: "review_list_detail_edit_final_grade",
  // 审核明细
  review_assign_list_export: "review_assign_list_export",
  review_assign_list_remark: "review_assign_list_remark",
  // 规则配置
  // review_rule_add: "ReviewRuleAdd",
  // review_rule_edit: "ReviewRuleEdit",
  // review_rule_detail: "ReviewRuleDetail",
  // review_rule_status: "review_rule_status",
  // review_rule_del: "review_rule_del",

  //  财务管理
  // 财务流水
  finance_bill_list_add: "finance_bill_list_add",
  finance_bill_list_export: "finance_bill_list_export",
  finance_bill_list_edit_amount: "finance_bill_list_edit_amount",
  // 订单账务
  finance_order_list_export: "finance_order_list_export",
  finance_order_list_edit_repay: "finance_order_list_edit_repay",
  finance_order_list_edit_amount: "finance_order_list_edit_amount",
  finance_order_list_offline_pay: "finance_order_list_offline_pay",
  finance_order_list_device_lock: "finance_order_list_device_lock",
  finance_order_list_handle_more: "finance_order_list_handle_more",
  // 门店结算
  finance_store_settle_export: "finance_store_settle_export",
  finance_store_settle_retry: "finance_store_settle_retry",
  finance_store_settle_offline_payment: "finance_store_settle_offline_payment",
  finance_store_settle_receipt_download: "finance_store_settle_receipt_download",

  //  门店管理
  // 门店列表
  store_list_add: "store_list_add",
  store_list_edit: "store_list_edit",
  store_list_detail: "store_list_detail",
  store_list_export: "store_list_export",
  store_list_del: "store_list_del",
  store_list_copy_link: "store_list_copy_link",
  store_list_material: "store_list_material",
  store_list_alipay_material: "store_list_alipay_material",
  store_list_status: "store_list_status",
  store_list_grade_config: "store_list_grade_config",
  store_list_combo_config: "store_list_combo_config",
  // store_list_wap_status: "store_list_wap_status",
  // 门店方案
  store_combo_detail: "store_combo_detail",
  store_combo_add: "store_combo_add",
  store_combo_edit: "store_combo_edit",
  store_combo_delete: "store_combo_delete",
  store_combo_status_edit: "store_combo_status_edit",
  // 商品属性
  store_goods_attr_add: "store_goods_attr_add",
  store_goods_attr_edit: "store_goods_attr_edit",
  // 商品列表
  store_goods_list_add: "store_goods_list_add",
  store_goods_ist_edit: "store_goods_ist_edit",
  store_goods_list_del: "store_goods_list_del",
  store_goods_list_status: "store_goods_list_status",

  //   商城管理
  // 商品列表
  mall_goods_list_add: "MallGoodsAdd",
  mall_goods_list_edit: "MallGoodsEdit",
  mall_goods_list_del: "mall_goods_list_del",
  mall_goods_list_status: "mall_goods_list_status",
  mall_goods_list_home_hot: "mall_goods_list_home_hot",
  mall_goods_list_home_recommend: "mall_goods_list_home_recommend",
  mall_goods_list_weight: "mall_goods_list_weight",
  // 商品分类
  mall_goods_cate_add: "mall_goods_cate_add",
  mall_goods_cate_edit: "mall_goods_cate_edit",
  mall_goods_cate_status: "mall_goods_cate_status",
  mall_goods_cate_del: "mall_goods_cate_del",

  //   商户管理
  // 商户列表
  merchant_list_add: "merchant_list_add",
  merchant_list_edit: "merchant_list_edit",
  merchant_list_del: "merchant_list_del",
  merchant_list_status: "merchant_list_status",

  // 资方管理
  // 资方列表
  capital_list_export: "capital_list_export",
  capital_list_add: "capital_list_add",
  capital_list_edit: "capital_list_edit",
  capital_list_recharge: "capital_list_recharge",
  capital_list_status: "capital_list_status",
  // 订单列表
  capital_order_list_export: "capital_order_list_export",
  capital_order_list_detail: "OrderDetail",
  capital_order_list_bill: "OrderBill",
  // 流水明细
  capital_bill_list_export: "capital_bill_list_export",
  capital_bill_list_add: "capital_bill_list_add",
  // 提现列表
  capital_withdraw_list_export: "capital_withdraw_list_export",
  capital_withdraw_list_review: "capital_withdraw_list_review",

  //   运营管理
  // 广告设置
  oprt_ad_list_add: 'oprt_ad_list_add',
  oprt_ad_list_edit: 'oprt_ad_list_edit',
  oprt_ad_list_link_config: 'oprt_ad_list_link_config',
  oprt_ad_list_status: 'oprt_ad_list_status',
  oprt_ad_list_del: 'oprt_ad_list_del',
  // 品牌管理
  oprt_brand_list_add: "oprt_brand_list_add",
  oprt_brand_list_edit: "oprt_brand_list_edit",
  oprt_brand_list_delete: "oprt_brand_list_delete",
  // 运营文案
  oprt_document_submit: "oprt_document_submit",
  // 协议合同
  oprt_protocol_submit: "oprt_protocol_submit",

  //  系统设置
  // 员工
  user_list_add: "user_list_add",
  user_list_edit: "user_list_edit",
  user_list_status: "user_list_status",
  user_list_del: "user_list_del",
  // 角色
  role_list_add: "role_list_add",
  role_list_edit: "role_list_edit",
  role_list_grant: "role_list_grant",
  role_list_del: "role_list_del",
  // 菜单
  menu_list_add: "menu_list_add",
  menu_list_edit: "menu_list_edit",
  menu_list_del: "menu_list_del",
  // 部门
  dept_list_add: "dept_list_add",
  dept_list_edit: "dept_list_edit",
  dept_list_del: "dept_list_del",
};
